const AdminRoutes = ({ children }) => {
    const isAuthenticated = true;
    return isAuthenticated ? (children) : null;
};

export default AdminRoutes;
